import { EulaActionTypes } from './types';
import { action } from 'typesafe-actions';

export const acceptEULAStart = () => action(EulaActionTypes.ACCEPT_EULA_START);
export const acceptEULASuccess = () =>
  action(EulaActionTypes.ACCEPT_EULA_SUCCESS);
export const acceptEULAFailure = (error: string) =>
  action(EulaActionTypes.ACCEPT_EULA_FAILURE, error);

export const getEULAStart = () => action(EulaActionTypes.GET_EULA_START);
export const getEULASuccess = (payload: string) =>
  action(EulaActionTypes.GET_EULA_SUCCESS, payload);
export const getEULAFailure = (error: string) =>
  action(EulaActionTypes.GET_EULA_FAILURE, error);
